const ArticleCategory = Object.freeze({
  ARTICLE: 'articles',
  EVENT: 'events',
  NEWS: 'news',
  VIDEO: 'videos'
})

export default ArticleCategory
